import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import _ from 'lodash';
export default {
  __name: 'kpiTableTd',
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    colspan: {
      type: Number
    }
  },
  setup(__props) {
    const props = __props;
    const fieldKey = computed(() => {
      if (!props.column.dataIndex) {
        return '';
      }
      if (Array.isArray(props.column.dataIndex)) {
        return props.column.dataIndex.join('.');
      }
      return props.column.dataIndex || '';
    });
    const cellText = computed(() => {
      return _.get(props.row, fieldKey.value, '');
    });
    const tdProps = computed(() => {
      const {
        customCell
      } = props.column;
      const resultProps = {};
      if (props.colspan) {
        resultProps.colspan = props.colspan;
      }
      if (customCell) {
        const {
          rowSpan,
          ...moreProps
        } = customCell(props.row);
        if (typeof rowSpan !== 'undefined') {
          resultProps.rowspan = rowSpan;
        } else {
          resultProps.rowspan = 1;
        }
        Object.assign(resultProps, moreProps);
      } else {
        resultProps.rowspan = 1;
      }
      return resultProps;
    });
    const CellContent = computed(() => {
      const {
        customRender
      } = props.column;
      if (customRender) {
        return () => customRender({
          record: props.row,
          text: cellText.value
        });
      }
      return () => cellText.value;
    });
    return (_ctx, _cache) => {
      return tdProps.value.rowspan > 0 ? (_openBlock(), _createElementBlock("td", _mergeProps({
        key: 0
      }, tdProps.value, {
        style: {
          "text-align": "center"
        }
      }), [_renderSlot(_ctx.$slots, "value", {
        Component: CellContent.value
      }, () => [_createVNode(_unref(CellContent))]), _renderSlot(_ctx.$slots, "extra")], 16)) : _createCommentVNode("", true);
    };
  }
};